import { useSelector } from "react-redux";
import "../App.css";
import constants from "../static/constants.json";
import AssignmentsView from "../components/WorkerViewAssignments";
function Assignments() {
  const user = useSelector((state: any) => state.user);
  
  const workerContent = (
    <AssignmentsView />
  )


  return (
    <div className="App">
      {user &&
        user.id &&
        user.personTypeId === constants.personType.worker &&
        workerContent}
      
    </div>
  );
}

export default Assignments;
